export const RESET_TIME = 'seamless-digital-idle-timeout-time';
export const HAS_SIGNED_OUT = 'seamless-digital-idle-timeout-has-timed-out';
